import Vue from "vue"
import VueRouter from "vue-router"
import store from "@/store"
import Home from "@/views/Home.vue"
import UserHome from "@/views/UserHome.vue"
import Films from "@/views/Films.vue"
import Film from "@/views/Film.vue"
import Lists from "@/views/Lists.vue"
import List from "@/views/List.vue"

Vue.use(VueRouter)

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home,
  },
  {
    path: "/profile",
    name: "Profile",
    component: UserHome,
    props: r => ({id: store.state.me.id})
  },
  {
    path: "/users/:id",
    name: "User",
    component: UserHome,
    props: true,
    beforeEnter(to, from, next) {
      if (to.params.id === store.state.me.id) {
        next({name: "Profile"})
      } else {
        next()
      }
    },
  },
  {
    path: "/films",
    name: "Films",
    component: Films,
  },
  {
    path: "/films/:id",
    name: "Film",
    component: Film,
    props: true,
  },
  {
    path: "/lists",
    name: "Lists",
    component: Lists,
  },
  {
    path: "/lists/:id",
    name: "List",
    component: List,
    props: true,
  },
]

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
})

export default router
